import React from "react";
import Chart from "react-apexcharts";

function chartStatic(data ) {
	var series = [] ;
	var label_status = [];
	var set_color = [] ; 
	var data1 = [] ; 
	var data2 = [] ; 
	var label1 = [] ; 
	var label2 = [] ; 
	if(data.data.length > 0){
		if(data.data?.length > 1 ){
			for(let i = 0 ; i < data.data.length ; i++){
				if(data.data[i].sla_type === "0"){
					data1.push(data.data[i].count_sla);
					label2.push('งานที่หลุดเป้า');
				}
				else
				{
					data2.push(data.data[i].count_sla);
					label1.push('งานที่ตามเป้าหมาย');
				}
			}
		}
		else
		{
			var checkType = 0 ; 
			for(let i = 0 ; i < data.data.length ; i++){
				if(data.data[i].sla_type === "0"){
					data1.push(data.data[i].count_sla);
					label2.push('งานที่หลุดเป้า');
					checkType = 0 ; 
				}
				else
				{
					data2.push(data.data[i].count_sla);
					label1.push('งานที่ตามเป้าหมาย');
					checkType = 1 ;
				}
			}
			if(checkType === 0 ){
				data1.push(0); 
				label2.push('งานที่หลุดเป้า');
			}
			else
			{
				data2.push(0); 
				label1.push('งานที่ตามเป้าหมาย');
			}
		}
		series = [data1[0] , data2[0]]
		label_status = [ label2[0], label1[0]]
		set_color = ['#E8CD00' ,  '#0500A3'] ; 

	}
	else
	{
		series = [0 , 0] ; 
		label_status = ['งานที่หลุดเป้า', 'งานที่ตามเป้าหมาย'];
		set_color = ['#D1CFCF', '#D1CFCF'] ; 
	}
	var options = {
		chart: {
			width: 500,
			type: 'donut',
		},
		colors: set_color,
		fill: {
			colors: set_color,
		},
		labels: label_status,
			dataLabels: {
				enabled: true,
				enabledOnSeries: undefined,
				formatter(val, opts) {
					// const name = opts.w.globals.labels[opts.seriesIndex]
					// return [val.toFixed(1) , name]
					return val.toFixed(1)
				}
			},
			// breakpoint: 800,
			options: {
				chart: {
					width: "300px"
				},
				legend: {
					show: true
				},
			} ,
		legend: {
		    show: true,
			fontSize: '10px',
			position: 'bottom',
			horizontalAlign: 'center',
			markers: {
				width: 5,
				height: 5,
				strokeWidth: 0,
				strokeColor: '#fff',
				radius: 12,
				onClick: undefined,
				offsetX: 0,
				offsetY: 0
			},
		},
		stroke: {
			width: 0,
			colors: ["#fff"]
		},
		plotOptions: {
			pie: {
				customScale: 1,
				donut: {
					labels: {
						show: true,
						total: {
							show: true,
							label: 'Jobs',
							fontSize: '10x',
							fontFamily: 'Montserrat, sans-serif',
							fontWeight: 400,
							color: '#41434A',
							formatter: function (w) {
								return w.globals.seriesTotals.reduce((a, b) => {
									return a + b
								}, 0)
							}
						}
					},

				},

			},
		},
	};
	return (
		<Chart options={options} series={series} type="donut" />
	)
}

export default chartStatic














